'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ZOOMIN = exports.ZOOMIN = 'zoomIn';
var ZOOMOUT = exports.ZOOMOUT = 'zoomOut';
var PAN = exports.PAN = 'pan';


//////////////////
// WEBPACK FOOTER
// ../rc-canvas/lib/ZoomPanModes.js
// module id = 91
// module chunks = 0